import agent from './agent'
import role from './util/role';
import jwtDecode from 'jwt-decode';
import { push } from "react-router-redux"
import {
  ASYNC_START,
  ASYNC_END,
  REGISTER,
  LOGIN,
  LOGOUT,
  PHONE_LOGIN_SUBMIT,
  LOGIN_PAGE_VERIFY_PIN_CODE,
  REFRESH_TOKEN_VERSION,
  CHANGE_PASSWORD_SUBMITTED,
  CHANGE_PHONE_SUBMITTED
} from './constants/actionTypes'

const promiseMiddleware = store => next => action => {
  if (isPromise(action.payload)) {
    store.dispatch({ type: ASYNC_START, subtype: action.type });

    const currentView = store.getState().viewChangeCounter;
    const skipTracking = action.skipTracking;

    action.payload.then(
      res => {
        const currentState = store.getState()
        if (!skipTracking && currentState.viewChangeCounter !== currentView) {
          return
        }
        console.log('RESULT', res);
        action.payload = res;
        store.dispatch({ type: ASYNC_END, promise: action.payload });
        store.dispatch(action);
      },
      error => {
        const currentState = store.getState()
        if (!skipTracking && currentState.viewChangeCounter !== currentView) {
          return
        }
        console.log('ERROR', error);
        action.error = true;
        action.payload = error.response.data;
        if (!action.skipTracking) {
          store.dispatch({ type: ASYNC_END, promise: action.payload });
        }
        //token is expired or inadequate permissions
        if (error.response.status === 401) {
          store.dispatch({ type: 'LOGOUT' });
        }
        store.dispatch(action);
      }
    );

    return;
  }
  next(action)
}

const localStorageMiddleware = store => next => action => {
  if (action.type === REGISTER || action.type === LOGIN || action.type === LOGIN_PAGE_VERIFY_PIN_CODE
    || action.type === PHONE_LOGIN_SUBMIT || action.type === REFRESH_TOKEN_VERSION || action.type === CHANGE_PASSWORD_SUBMITTED
    || action.type === CHANGE_PHONE_SUBMITTED) {
    if (!action.error && action.payload.user && action.payload.user.token) {
      window.localStorage.setItem('pellar-file-web-token', action.payload.user.token);
      agent.setToken(action.payload.user.token);
    }
  } else if (action.type === LOGOUT) {
    window.localStorage.setItem('pellar-file-web-token', '')
    agent.setToken(null)
  }
  next(action)
}

function isPromise(v) {
  return v && typeof v.then === 'function'
}

export { promiseMiddleware, localStorageMiddleware }
